import { render, staticRenderFns } from "./LoginsLog.vue?vue&type=template&id=29831a20&"
import script from "./LoginsLog.vue?vue&type=script&lang=tsx&"
export * from "./LoginsLog.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports